import React from 'react';
import Reactions from 'app/components/post/Reactions';
import EngagementBarLayout from 'app/components/post/EngagementBarLayout';
import { Button } from 'app/seedly-component-library';
import { UPVOTER_TYPE } from 'app/constants/app';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { MessageCircle, Share2 as Share } from 'react-feather';

const Footer = props => {
  const { openShareModal, review } = props;
  const { id, commentsCount, upvoted, upvotesCount } = review;

  return (
    <div style={{ marginTop: '16px', marginBottom: '8px' }}>
      <EngagementBarLayout
        commentsCount={commentsCount}
        commentButton={<Button icon={<MessageCircle />} disabled />}
        shareButton={
          <Button
            onClick={() => {
              openShareModal();
              mixpanel.track(trackedEvents.CommentThread, {
                param: 'share',
                category: 'review',
              });
            }}
            icon={<Share />}
          />
        }
        reactionButton={
          <Reactions
            id={id}
            upvoted={upvoted}
            upvoteCount={upvotesCount}
            type={UPVOTER_TYPE.REVIEW}
          />
        }
      />
    </div>
  );
};

export default Footer;
